import { useQuery } from '@tanstack/react-query';

import { fetchCustomerEquipmentTypes } from '../../data-provider/select-options';
import type { GetCustomerEquipmentTypesRequestParams } from '../../data-provider/select-options/shipment-customer-equipment-type/api';

export const useGetCustomerEquipmentTypes = (params: Partial<GetCustomerEquipmentTypesRequestParams>) => {
  return useQuery({
    enabled: Boolean(params.CustomerKey),
    queryFn: () => fetchCustomerEquipmentTypes(params as GetCustomerEquipmentTypesRequestParams),
    queryKey: ['shipment-customer-equipment-types-list', params],
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
